import script from "./GroupPurchaseEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./GroupPurchaseEdit.vue?vue&type=script&setup=true&lang=js"

import "./GroupPurchaseEdit.vue?vue&type=style&index=0&id=7be84f90&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7be84f90"]])

export default __exports__